import { create } from 'zustand'
import { SoundState } from './SoundState'
import { NotePlayer } from './NotePlayer'
import { useVolume } from '../Course/CourseStore'

export const useSoundStore = create<SoundState>()(
  (setter) => new SoundState(setter)
)
export function useNotePlayer(){
    const volume:number = useVolume()
    const notePlayer:NotePlayer = useSoundStore((state:SoundState)=>{
      state.notePlayer.setVolume(volume)
      return state.notePlayer
    })
    return notePlayer
}